export const WORKFLOW_TYPES = Object.freeze({
  DIRECT_FINAL: "DIRECT_FINAL",
  ACCEPTANCE_REQUIRED: "ACCEPTANCE_REQUIRED",
  RETURN_APPROVAL: "RETURN_APPROVAL",
});